<button
	[id]="openable() ? triggerId : null"
	(click)="handleClick()"
	class="btn btn-neutral"
	data-test-class="filter-sheet-button"
>
	@if (iconLeading()) {
		<svg-icon
			[src]="iconLeading()"
			class="pointer-events-none size-4 grow-0"
		/>
	}
	<span class="pointer-events-none">{{ label() }}</span>
	@if (indicator()) {
		<span
			class="pointer-events-none flex size-4 items-center justify-center rounded-full bg-primary-100 text-xs leading-none text-white"
		>
			{{ indicator() }}
		</span>
	}
	@if (openable()) {
		<svg-icon
			class="pointer-events-none size-4 grow-0"
			src="assets/icons/icon-chevron-down.svg"
		/>
	}
</button>

@if (openable()) {
	<vp-sheet
		#filterSheet
		[isLoading]="false"
		[triggerId]="triggerId"
		sheetAlignment="right"
		sheetWidth="third"
	>
		<vp-sheet-header>
			<span class="h2 text-xl font-bold">
				{{ 'compositions.filters.sheet.header' | translate }}
			</span>
		</vp-sheet-header>
		<vp-sheet-content>
			<ng-content></ng-content>
		</vp-sheet-content>
		<vp-sheet-footer>
			<button (click)="filterSheet.hide()" class="btn w-full btn-primary">
				{{
					'compositions.filters.sheet.footer'
						| translate: { amount: numberOfResults() }
				}}
			</button>
		</vp-sheet-footer>
	</vp-sheet>
}
